import { useEffect, useState } from "react";
import { useDataProvider, useStore } from "react-admin";
import { useLocation } from "react-router-dom";

import CreateBulgarianCandidacy from "./Bulgarian";
import CreateIntermediaryCandidacy from "./Intermediary";
import { CampaignSubTypes } from "utils/constants";
import { candidateRequests } from "api/candidateApi";

const CreateRegularCandidate = () => {
  const dataProvider = useDataProvider();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const type = params.get("type");
  const [title, setTitle] = useState(null);

  // Read-only consumer of the committed campaign from the regular candidates list.
  const [filters] = useStore(`campaign-query-subtype-${CampaignSubTypes.Regular}`, null);
  const campaignId = filters?.campaignId ?? null;

  useEffect(() => {
    const fetchCampaignTitle = async () => {
      try {
        const { data } = await dataProvider.customRequest(
          candidateRequests.getPreliminaryCampaignsSelect(CampaignSubTypes.Regular),
        );
        setTitle(data.find(option => option.id === +campaignId)?.nameBg ?? null);
      } catch (error) {
        console.error("Неуспешно зареждане на кампанията", error);
      }
    };

    fetchCampaignTitle();
  }, [campaignId, dataProvider]);
  return type === "Bg" ? <CreateBulgarianCandidacy title={title} /> : <CreateIntermediaryCandidacy title={title} />;
};
export default CreateRegularCandidate;
